import { Box, type SxProps, type Theme } from '@mui/material';

import { sanitiseRichText } from '@/components/sanitiseRichText';

export function RichTextContent({ value, sx }: { value: string; sx?: SxProps<Theme> }) {
  return (
    <Box
      sx={{
        overflowWrap: 'anywhere',
        '& p': { my: 0.5 },
        '& ul, & ol': { my: 0.5, pl: 3 },
        '& small': { color: 'text.secondary' },
        '& a': { color: 'primary.main' },
        ...sx,
      }}
      dangerouslySetInnerHTML={{ __html: sanitiseRichText(value) }}
    />
  );
}
